import { defineMessages, MessageDescriptor } from 'react-intl';

/**
 * Message descriptors for group form success notifications (created vs updated).
 */
export const groupNotificationMessages: {
  created: MessageDescriptor;
  updated: MessageDescriptor;
} = defineMessages({
  created: {
    id: 'admin.groups.notifications.created',
    defaultMessage: 'Grupo creado',
  },
  updated: {
    id: 'admin.groups.notifications.updated',
    defaultMessage: 'Grupo actualizado',
  },
});
